import { ApiError } from '@frontend/api-utils';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { WorkflowActionClient } from '../api/workflow-action-client';
import { WorkflowActionTemplateClient } from '../api/workflow-action-template-client';
import { WorkflowTriggerClient } from '../api/workflow-trigger-client';
import { WorkflowActionFieldTemplate } from '../workflow-action-field-template';

interface WorkflowSharedState {
    actions: { [key: string]: string } | null;
    triggers: { [key: string]: string } | null;

    actionFieldTemplates: { [key: string]: WorkflowActionFieldTemplate[] } | null;
}

const initialState: WorkflowSharedState = {
    actions: null,
    triggers: null,
    actionFieldTemplates: null
};

export const workflowSharedSlice = createSlice({
    name: 'workflowShared',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorkflowActions.fulfilled, (state, action) => {
                state.actions = action.payload;
            })
            .addCase(fetchWorkflowTriggers.fulfilled, (state, action) => {
                state.triggers = action.payload;
            })
            .addCase(fetchWorkflowActionFieldTemplates.fulfilled, (state, action) => {
                state.actionFieldTemplates = action.payload;
            });
    }
});

export const fetchWorkflowActionFieldTemplates = createAsyncThunk<{ [key: string]: WorkflowActionFieldTemplate[] }>(
    'fetchWorkflowActionFieldTemplates',
    async (_, { rejectWithValue }) => {
        try {
            return await WorkflowActionTemplateClient.fetchWorkflowActionFieldTemplates();
        } catch (e) {
            if ((e as ApiError).json) return rejectWithValue(e);
            throw e;
        }
    }
);

export const fetchWorkflowActions = createAsyncThunk<{ [key: string]: string }>('fetchWorkflowActions', async (_, { rejectWithValue }) => {
    try {
        return await WorkflowActionClient.fetchWorkflowActions();
    } catch (e) {
        if ((e as ApiError).json) return rejectWithValue(e);
        throw e;
    }
});

export const fetchWorkflowTriggers = createAsyncThunk<{ [key: string]: string }>('fetchWorkflowTriggers', async (_, { rejectWithValue }) => {
    try {
        return await WorkflowTriggerClient.fetchWorkflowTriggers();
    } catch (e) {
        if ((e as ApiError).json) return rejectWithValue(e);
        throw e;
    }
});
